"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentUrl = exports.getCurrentReferrer = exports.getTopLevelDomain = exports.getSubdomain = exports.getLocalDomain = exports.isLocalDomain = exports.getRootDomain = void 0;

var _misc = require("./misc");

var _logger = _interopRequireDefault(require("./logger"));

var Url = require('url-parse');

var getRootDomain = function getRootDomain(url) {
  var parsed = new Url(url);
  var hostnamePortions = parsed.hostname.split('.');
  return hostnamePortions.slice(hostnamePortions.length - 2, hostnamePortions.length).join('.');
};

exports.getRootDomain = getRootDomain;

var isLocalDomain = function isLocalDomain(url) {
  var parsed = new Url(url);
  var hostnamePortions = parsed.hostname.split('.');
  return !isNaN(Number(hostnamePortions[0]));
};

exports.isLocalDomain = isLocalDomain;

var getLocalDomain = function getLocalDomain(url) {
  var parsed = new Url(url);
  var hostnamePortions = parsed.hostname.split('.');
  return hostnamePortions[0];
};

exports.getLocalDomain = getLocalDomain;

var getSubdomain = function getSubdomain(url) {
  var parsed = new Url(url);
  var hostnamePortions = parsed.hostname.split('.');

  if (hostnamePortions.length >= 3) {
    return hostnamePortions[0];
  } else {
    return;
  }
};

exports.getSubdomain = getSubdomain;

var getTopLevelDomain = function getTopLevelDomain(url) {
  var parsed = new Url(url);
  var hostnamePortions = parsed.hostname.split('.');
  var topLevelDomain = hostnamePortions[hostnamePortions.length - 1];

  if (isNaN(Number(topLevelDomain))) {
    return topLevelDomain;
  } else {
    // If last segment of hostname is a number, we are hitting an ip directly (likely in test env)
    // In this case, use fallback
    return 'tst';
  }
};

exports.getTopLevelDomain = getTopLevelDomain;

var getCurrentReferrer = function getCurrentReferrer(exitingReferrer) {
  var currentReferrer;

  if (!(0, _misc.noWindow)()) {
    // If there is a window object, check if exitingReferrer and current window referrer is same,
    // if its same, then set it to chegg.com,
    // if its not same, then set it to current window referrer
    if (exitingReferrer === window.document.referrer) {
      currentReferrer = 'www.chegg.com';
    } else {
      currentReferrer = window.document.referrer;
    }
  } else if (exitingReferrer) {
    // If there is no window object, we're on the server side, and the
    // initiating app should have fed in the referrer. Use this.
    currentReferrer = exitingReferrer;
  } else {
    // Looks like the initiating app never gave us a url.
    // Alert and return an empty string.
    currentReferrer = '';
  }

  return currentReferrer;
};

exports.getCurrentReferrer = getCurrentReferrer;

var getCurrentUrl = function getCurrentUrl(urlFromState) {
  var currentUrl;

  if (urlFromState) {
    // if initiating app have fed in the url. Use this as current url.
    currentUrl = urlFromState;
  } else if (!(0, _misc.noWindow)()) {
    // If there is a window object, always go to it for the latest URL
    currentUrl = window.location.href;
  } else {
    // Looks like the initiating app never gave us a url.
    // Alert and return an empty string.
    _logger["default"].error(new Error('No url passed into state'));

    currentUrl = '';
  }

  return currentUrl;
};

exports.getCurrentUrl = getCurrentUrl;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-sdk-web/dist/cjs/utils/urls.js
// module id = 628
// module chunks = 11